export const siteConfig = {
  name: '福利导航网',
  tagline: '一站式福利资源聚合平台',
  description: '福利导航网是专为用户打造的一站式福利资源聚合平台，汇集海量优惠券、折扣活动、会员福利、返利信息及限时特惠，帮助您快速找到最新最全的福利资源，省钱省时更省心。',
  keywords: '福利导航网,福利资源导航,优惠券聚合,折扣福利网站,会员福利平台,返利导航,限时特惠导航',
  url: 'https://www.fulidaohang.com',
  email: 'contact@fulidaohang.com',
  phone: '400-888-6666',
  address: '北京市海淀区中关村科技园',
};

export const categories = [
  { id: 'all', name: '全部福利', icon: 'ri-apps-line', description: '浏览所有福利资源' },
  { id: 'coupon', name: '优惠券', icon: 'ri-coupon-line', description: '各大平台优惠券合集' },
  { id: 'discount', name: '折扣活动', icon: 'ri-percent-line', description: '限时折扣，超值好物' },
  { id: 'member', name: '会员福利', icon: 'ri-vip-crown-line', description: '会员专属特权福利' },
  { id: 'rebate', name: '返利信息', icon: 'ri-refund-2-line', description: '购物返利，边买边赚' },
  { id: 'flash', name: '限时特惠', icon: 'ri-flashlight-line', description: '秒杀抢购，手慢无' },
];

export interface WelfareItem {
  id: string;
  title: string;
  description: string;
  category: string;
  platform: string;
  discount: string;
  originalPrice: string;
  currentPrice: string;
  expiryDate: string;
  imageUrl: string;
  hot: boolean;
  url: string;
}

export const welfareItems: WelfareItem[] = [
  {
    id: 'w1',
    title: '京东618超值优惠券大礼包',
    description: '满199减100、满299减150，全场通用，限时领取！涵盖数码、家电、服饰等多个品类，先到先得。',
    category: 'coupon',
    platform: '京东',
    discount: '满199减100',
    originalPrice: '¥199',
    currentPrice: '¥99',
    expiryDate: '2026-08-15',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20e-commerce%20shopping%20scene%20with%20warm%20ambient%20lighting%2C%20discount%20coupon%20concept%2C%20clean%20minimal%20background%20with%20soft%20warm%20tones%2C%20lifestyle%20product%20photography%20with%20shallow%20depth%20of%20field%2C%20cozy%20and%20inviting%20atmosphere%2C%20professional%20commercial%20photography%20style&width=600&height=400&seq=welfare-jd-coupon-01&orientation=landscape',
    hot: true,
    url: '#',
  },
  {
    id: 'w2',
    title: '天猫超市全场5折起',
    description: '日用百货、零食饮料、母婴用品全品类参与，满88包邮，新人首单再减10元。',
    category: 'discount',
    platform: '天猫',
    discount: '5折起',
    originalPrice: '¥200',
    currentPrice: '¥100',
    expiryDate: '2026-08-20',
    imageUrl: 'https://readdy.ai/api/search-image?query=E-commerce%20groceries%20and%20daily%20goods%20discount%20concept%2C%20warm%20orange%20and%20beige%20tones%2C%20clean%20minimal%20background%2C%20soft%20natural%20lighting%2C%20lifestyle%20shopping%20photography%20with%20products%20neatly%20arranged&width=600&height=400&seq=welfare-tmall-discount-01&orientation=landscape',
    hot: true,
    url: '#',
  },
  {
    id: 'w3',
    title: '饿了么超级会员月卡免费领',
    description: '新用户专享，免费领取饿了么超级会员月卡，享受免配送费、专属折扣等特权。',
    category: 'member',
    platform: '饿了么',
    discount: '免费领取',
    originalPrice: '¥15',
    currentPrice: '¥0',
    expiryDate: '2026-08-31',
    imageUrl: 'https://readdy.ai/api/search-image?query=Food%20delivery%20app%20membership%20benefits%20concept%2C%20warm%20and%20inviting%20atmosphere%2C%20orange%20and%20gold%20tones%2C%20clean%20minimal%20background%2C%20fresh%20food%20visuals%20in%20soft%20lighting&width=600&height=400&seq=welfare-eleme-member-01&orientation=landscape',
    hot: true,
    url: '#',
  },
  {
    id: 'w4',
    title: '拼多多百亿补贴返利专场',
    description: '通过本链接进入拼多多百亿补贴专场，下单后最高返现50元，真实有效，提现秒到账。',
    category: 'rebate',
    platform: '拼多多',
    discount: '最高返50元',
    originalPrice: '¥299',
    currentPrice: '¥249',
    expiryDate: '2026-08-25',
    imageUrl: 'https://readdy.ai/api/search-image?query=Online%20shopping%20cashback%20and%20rebate%20concept%2C%20warm%20golden%20and%20green%20accents%2C%20minimal%20clean%20background%2C%20coins%20and%20savings%20visual%20metaphor%2C%20soft%20editorial%20lighting%2C%20modern%20aesthetic&width=600&height=400&seq=welfare-pdd-rebate-01&orientation=landscape',
    hot: false,
    url: '#',
  },
  {
    id: 'w5',
    title: '美团外卖每日限时秒杀',
    description: '每天10点、14点、18点准时开抢，1元秒杀奶茶、9.9元抢购套餐，手慢无！',
    category: 'flash',
    platform: '美团',
    discount: '1元起',
    originalPrice: '¥25',
    currentPrice: '¥1',
    expiryDate: '2026-08-08',
    imageUrl: 'https://readdy.ai/api/search-image?query=Flash%20sale%20countdown%20concept%20with%20warm%20urgent%20vibe%2C%20orange%20and%20red%20accents%2C%20clean%20background%20with%20clock%20imagery%2C%20dynamic%20energy%2C%20e-commerce%20promotional%20aesthetic%20with%20soft%20lighting&width=600&height=400&seq=welfare-meituan-flash-01&orientation=landscape',
    hot: true,
    url: '#',
  },
  {
    id: 'w6',
    title: '淘宝隐藏优惠券挖掘教程',
    description: '教你如何挖掘淘宝隐藏大额优惠券，购物前必看，省下的钱超乎想象。包含详细操作步骤。',
    category: 'coupon',
    platform: '淘宝',
    discount: '最高减80%',
    originalPrice: '¥100',
    currentPrice: '¥20',
    expiryDate: '长期有效',
    imageUrl: 'https://readdy.ai/api/search-image?query=Hidden%20discount%20coupon%20discovery%20concept%2C%20magnifying%20glass%20over%20shopping%20cart%2C%20warm%20beige%20and%20golden%20tones%2C%20clean%20minimal%20background%2C%20treasure%20hunt%20vibe%2C%20soft%20editorial%20lighting&width=600&height=400&seq=welfare-taobao-coupon-01&orientation=landscape',
    hot: false,
    url: '#',
  },
  {
    id: 'w7',
    title: '网易严选Pro会员年卡5折',
    description: '网易严选Pro会员年卡限时5折，开通即享全年免邮、专属价、优先购等超级权益。',
    category: 'member',
    platform: '网易严选',
    discount: '5折',
    originalPrice: '¥149',
    currentPrice: '¥74.5',
    expiryDate: '2026-08-28',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20membership%20card%20concept%20with%20VIP%20aesthetic%2C%20warm%20gold%20and%20cream%20tones%2C%20elegant%20minimal%20background%2C%20exclusive%20privileges%20visual%2C%20soft%20natural%20lighting%2C%20lifestyle%20photography%20style&width=600&height=400&seq=welfare-wangyi-member-01&orientation=landscape',
    hot: false,
    url: '#',
  },
  {
    id: 'w8',
    title: '苏宁易购家电换新补贴',
    description: '以旧换新额外补贴，空调、冰箱、洗衣机最高补贴500元，免费上门拆旧装新一条龙服务。',
    category: 'discount',
    platform: '苏宁易购',
    discount: '最高补贴500元',
    originalPrice: '¥2999',
    currentPrice: '¥2499',
    expiryDate: '2026-09-10',
    imageUrl: 'https://readdy.ai/api/search-image?query=Home%20appliance%20trade-in%20and%20subsidy%20concept%2C%20modern%20kitchen%20with%20appliances%2C%20warm%20neutral%20tones%2C%20clean%20minimal%20background%2C%20professional%20product%20photography%20with%20soft%20natural%20lighting&width=600&height=400&seq=welfare-suning-discount-01&orientation=landscape',
    hot: true,
    url: '#',
  },
  {
    id: 'w9',
    title: '滴滴出行新用户百元礼包',
    description: '滴滴出行新用户注册即送100元出行礼包，包含快车、专车、顺风车等多场景优惠券。',
    category: 'coupon',
    platform: '滴滴出行',
    discount: '送100元礼包',
    originalPrice: '¥100',
    currentPrice: '¥0',
    expiryDate: '2026-08-30',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ride-hailing%20app%20new%20user%20gift%20package%20concept%2C%20urban%20transportation%20theme%2C%20warm%20orange%20and%20beige%20tones%2C%20clean%20minimal%20background%2C%20modern%20city%20vibe%20with%20soft%20lighting&width=600&height=400&seq=welfare-didi-coupon-01&orientation=landscape',
    hot: false,
    url: '#',
  },
  {
    id: 'w10',
    title: '唯品会品牌特卖3折封顶',
    description: '唯品会品牌特卖专场，大牌正品3折封顶，每日更新，限时抢购，错过再等一年。',
    category: 'flash',
    platform: '唯品会',
    discount: '3折封顶',
    originalPrice: '¥500',
    currentPrice: '¥150',
    expiryDate: '2026-08-12',
    imageUrl: 'https://readdy.ai/api/search-image?query=Brand%20clearance%20sale%20concept%20with%20luxury%20vibe%2C%20warm%20pink%20and%20rose%20gold%20tones%2C%20fashion%20items%20display%2C%20clean%20minimal%20background%2C%20soft%20editorial%20lighting%2C%20elegant%20commercial%20photography&width=600&height=400&seq=welfare-vipshop-flash-01&orientation=landscape',
    hot: true,
    url: '#',
  },
  {
    id: 'w11',
    title: '抖音电商新人有礼红包',
    description: '抖音电商新人首单立减15元，全场通用无门槛，还可叠加店铺优惠券使用。',
    category: 'coupon',
    platform: '抖音电商',
    discount: '立减15元',
    originalPrice: '¥30',
    currentPrice: '¥15',
    expiryDate: '2026-08-22',
    imageUrl: 'https://readdy.ai/api/search-image?query=Social%20media%20e-commerce%20new%20user%20gift%20concept%2C%20modern%20smartphone%20with%20shopping%20app%2C%20warm%20gradient%20background%2C%20clean%20minimal%20aesthetic%2C%20soft%20natural%20lighting%2C%20lifestyle%20photography&width=600&height=400&seq=welfare-douyin-coupon-01&orientation=landscape',
    hot: false,
    url: '#',
  },
  {
    id: 'w12',
    title: '返利网超级返活动来袭',
    description: '通过返利网下单，享受最高80%返利，支持淘宝、京东、拼多多等主流平台，提现无门槛。',
    category: 'rebate',
    platform: '返利网',
    discount: '最高返80%',
    originalPrice: '¥200',
    currentPrice: '¥40',
    expiryDate: '长期有效',
    imageUrl: 'https://readdy.ai/api/search-image?query=Super%20cashback%20and%20rebate%20platform%20concept%2C%20golden%20coins%20and%20money%20visual%2C%20warm%20amber%20and%20green%20tones%2C%20clean%20minimal%20background%2C%20prosperity%20and%20savings%20theme%2C%20soft%20editorial%20lighting&width=600&height=400&seq=welfare-fanli-rebate-01&orientation=landscape',
    hot: false,
    url: '#',
  },
];

export interface Article {
  id: string;
  title: string;
  summary: string;
  contentHtml: string;
  category: string;
  author: string;
  publishDate: string;
  imageUrl: string;
  tags: string[];
}

export const articles: Article[] = [
  {
    id: 'a1',
    title: '2026年8月最新优惠券领取全攻略',
    summary: '汇总整理8月各大电商平台最新优惠券领取入口，包含淘宝、京东、拼多多、抖音等主流平台，手把手教你领券省钱。',
    contentHtml: '<h3>引言</h3><p>每到月初，各大电商平台都会放出新一轮的优惠券活动。作为精明的消费者，掌握优惠券领取技巧至关重要。本文将为你详细汇总2026年8月各大平台的最新优惠券领取攻略。</p><h3>一、淘宝/天猫优惠券</h3><p>淘宝和天猫本月推出了"夏日狂欢"主题活动，优惠券种类丰富：</p><ul><li><strong>品类券：</strong>服饰类满200减30，数码类满1000减100，美妆类满300减50。</li><li><strong>店铺券：</strong>关注店铺即可领取5-50元不等优惠券，部分大牌店铺还有会员专属券。</li><li><strong>隐藏券：</strong>通过淘宝客链接可以领取隐藏大额优惠券，折扣力度通常比公开券更大。</li></ul><h3>二、京东优惠券</h3><p>京东8月主推"京东超品日"，优惠力度空前：</p><ul><li><strong>PLUS会员券：</strong>PLUS会员专享满199减100神券，每天限量发放。</li><li><strong>京贴：</strong>跨店满减券，满300减40，可与其他优惠叠加使用。</li><li><strong>白条券：</strong>使用京东白条支付额外享受满减优惠。</li></ul><h3>三、拼多多优惠券</h3><p>拼多多一向以低价著称，8月的优惠活动同样给力：</p><ul><li><strong>百亿补贴券：</strong>每天10点、20点限量发放，先到先得。</li><li><strong>多多果园：</strong>浇水种树可获得无门槛优惠券。</li><li><strong>砍价免费拿：</strong>邀请好友帮忙砍价，有机会0元购。</li></ul><h3>四、抖音电商优惠券</h3><p>抖音电商8月推出"818好物节"：</p><ul><li><strong>新人券：</strong>新用户首单立减15元，无门槛使用。</li><li><strong>直播间券：</strong>关注主播直播间可领取专属优惠券。</li><li><strong>品牌券：</strong>各大品牌官方旗舰店发放的品牌专属券。</li></ul><h3>总结</h3><p>以上是2026年8月各大平台优惠券领取攻略汇总。建议在购物前先到福利导航网查看最新优惠信息，让每一次购物都物超所值！</p>',
    category: 'coupon',
    author: '福利小助手',
    publishDate: '2026-08-05',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20coupon%20guide%20article%20illustration%2C%20warm%20minimal%20aesthetic%2C%20e-commerce%20shopping%20theme%2C%20soft%20natural%20lighting%2C%20editorial%20photography%20style%20with%20clean%20composition&width=400&height=300&seq=article-coupon-guide-01&orientation=landscape',
    tags: ['优惠券', '购物攻略', '电商平台', '省钱技巧'],
  },
  {
    id: 'a2',
    title: '会员福利大盘点：这些隐藏权益你都知道吗？',
    summary: '京东PLUS、淘宝88VIP、美团会员、饿了么超级会员...各大平台会员福利深度对比，帮你选出最值得开通的会员。',
    contentHtml: '<h3>引言</h3><p>如今，各大平台都推出了自己的会员体系。但你真的了解每种会员的全部权益吗？很多隐藏福利你可能从未用过。本文将为你深度盘点各大平台会员福利，帮你把会员费"赚"回来。</p><h3>京东PLUS会员</h3><p>京东PLUS会员年费149元，核心权益包括：</p><ul><li><strong>10倍京豆：</strong>购物返10倍京豆，100京豆=1元，购物越多返得越多。</li><li><strong>360元运费券：</strong>每月5张6元运费券，全年价值360元。</li><li><strong>PLUS会员价：</strong>海量商品享受PLUS专享价。</li><li><strong>隐藏福利：</strong>PLUS会员可免费领取爱奇艺/腾讯视频等联名会员。</li></ul><h3>淘宝88VIP</h3><p>88VIP年费88元（淘气值1000以上），权益极为丰富：</p><ul><li><strong>95折优惠：</strong>天猫超市、天猫国际等享95折。</li><li><strong>联名会员：</strong>赠送优酷VIP、网易云音乐黑胶VIP、饿了么超级会员等。</li><li><strong>专属客服：</strong>优先接入人工客服。</li></ul><h3>美团会员</h3><p>美团会员月费15元，外卖达人必备：</p><ul><li><strong>30元红包：</strong>每月6张5元无门槛外卖红包。</li><li><strong>会员价菜品：</strong>部分商家提供会员专属价格。</li></ul><h3>总结对比</h3><p>从性价比来看，88VIP以88元年费送多个联名会员最为超值；京东PLUS适合在京东购物较多的用户；美团会员对外卖用户最实用。建议根据自身消费习惯选择最合适的会员。</p>',
    category: 'member',
    author: '省钱达人',
    publishDate: '2026-08-03',
    imageUrl: 'https://readdy.ai/api/search-image?query=VIP%20membership%20benefits%20illustration%2C%20warm%20golden%20and%20cream%20tones%2C%20premium%20lifestyle%20theme%2C%20soft%20natural%20lighting%2C%20editorial%20photography%20style%20with%20clean%20composition&width=400&height=300&seq=article-member-guide-01&orientation=landscape',
    tags: ['会员福利', '京东PLUS', '88VIP', '美团会员', '权益对比'],
  },
  {
    id: 'a3',
    title: '返利平台哪家强？2026年主流返利平台全面评测',
    summary: '返利网、一淘、蜜源、粉象生活...市面上返利平台层出不穷，哪个返利最高？哪个提现最快？本文为你一一揭晓。',
    contentHtml: '<h3>引言</h3><p>返利购物已经成为越来越多消费者的选择。同样的商品，通过返利平台下单可以获得额外返现，长期下来能省不少钱。但面对市场上众多返利平台，该如何选择呢？</p><h3>主流返利平台对比</h3><h4>返利网</h4><p>作为老牌返利平台，返利网返利比例通常在1%-30%之间，覆盖淘宝、京东、拼多多等主流电商平台。提现门槛低，1元即可提现。</p><h4>一淘</h4><p>阿里巴巴旗下返利平台，在淘宝/天猫的返利比例较高，但其他平台覆盖较少。支持集分宝提现。</p><h4>蜜源</h4><p>社交返利平台，通过分享模式可以获得更高返利。适合有社交资源的用户。</p><h4>粉象生活</h4><p>综合返利+优惠券平台，返利比例中上，APP体验较好，适合普通用户日常使用。</p><h3>使用技巧</h3><p>1. <strong>多平台比价：</strong>不同返利平台的返利比例可能不同，建议下单前多平台比较。</p><p>2. <strong>叠加优惠券：</strong>返利和优惠券可以同时使用，先领券再通过返利链接下单。</p><p>3. <strong>关注活动日：</strong>各大返利平台在节假日通常会有翻倍返利活动。</p><h3>总结</h3><p>建议普通用户使用返利网或粉象生活，覆盖广、操作简单；淘宝重度用户推荐一淘；有社交资源的可以考虑蜜源赚取更多返利。</p>',
    category: 'rebate',
    author: '福利小助手',
    publishDate: '2026-08-01',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cashback%20platform%20review%20illustration%2C%20warm%20amber%20and%20green%20accents%2C%20money%20savings%20theme%2C%20soft%20natural%20lighting%2C%20editorial%20photography%20style%20with%20clean%20composition&width=400&height=300&seq=article-rebate-guide-01&orientation=landscape',
    tags: ['返利平台', '购物返利', '省钱攻略', '平台评测'],
  },
  {
    id: 'a4',
    title: '限时秒杀技巧：如何提高抢购成功率？',
    summary: '限时秒杀看似靠运气，其实有技巧可循。掌握这些方法，让你在秒杀中快人一步，抢到心仪好物。',
    contentHtml: '<h3>引言</h3><p>限时秒杀是各大平台吸引用户的重要手段，1元秒杀、9.9元抢购等超低价商品让人心动不已。但很多人抱怨"永远抢不到"。其实，秒杀也有技巧可循。</p><h3>秒杀前的准备</h3><p>1. <strong>提前加购物车：</strong>大多数平台允许将秒杀商品提前加入购物车，到点直接结算。</p><p>2. <strong>完善收货地址：</strong>提前设置默认收货地址，减少下单步骤。</p><p>3. <strong>确保网络通畅：</strong>使用WiFi或5G网络，关闭其他占用带宽的应用。</p><p>4. <strong>校准时间：</strong>使用网络时间校准，确保与服务器时间同步。</p><h3>秒杀时的技巧</h3><p>1. <strong>提前进入页面：</strong>在秒杀开始前30秒不断刷新页面。</p><p>2. <strong>使用快捷支付：</strong>设置免密支付或指纹支付，减少支付时间。</p><p>3. <strong>不要犹豫：</strong>看到能下单就立即支付，犹豫一秒可能就没了。</p><h3>总结</h3><p>秒杀成功的核心在于"快"和"准备充分"。提前做好上述准备，你的秒杀成功率将大幅提升。</p>',
    category: 'flash',
    author: '抢购达人',
    publishDate: '2026-07-28',
    imageUrl: 'https://readdy.ai/api/search-image?query=Flash%20sale%20countdown%20illustration%2C%20warm%20orange%20and%20red%20accents%2C%20urgent%20shopping%20theme%2C%20soft%20natural%20lighting%2C%20editorial%20photography%20style%20with%20clean%20composition&width=400&height=300&seq=article-flash-guide-01&orientation=landscape',
    tags: ['秒杀技巧', '限时抢购', '购物攻略', '抢购经验'],
  },
  {
    id: 'a5',
    title: '双11提前看：2026年双十一省钱攻略抢先版',
    summary: '虽然离双11还有三个月，但提前规划能省更多！本文为你预测2026年双十一各大平台玩法，教你提前布局省钱计划。',
    contentHtml: '<h3>引言</h3><p>每年双十一都是全民购物狂欢节，各大平台的优惠力度也是一年之最。虽然现在还只是8月，但提前了解双十一的玩法和省钱技巧，能让你在双11当天轻松省下上千元。</p><h3>各平台玩法预测</h3><h4>天猫双11</h4><p>预计继续推出跨店满减（满300减50）、品类券、红包雨等经典玩法。88VIP会员还将享受额外折扣。</p><h4>京东双11</h4><p>PLUS会员超级补贴、京贴、白条免息分期等仍是主力玩法。京东的数码家电品类依旧是最大看点。</p><h4>拼多多双11</h4><p>百亿补贴继续加码，部分商品价格可能比天猫京东更低。适合购买日用百货等低客单价商品。</p><h3>提前准备清单</h3><p>1. <strong>列购物清单：</strong>提前想好需要购买的商品，避免冲动消费。</p><p>2. <strong>设预算上限：</strong>设定双十一总预算，防止超支。</p><p>3. <strong>关注价格走势：</strong>通过比价工具查看历史价格，确保是真实优惠。</p><p>4. <strong>开通会员：</strong>提前开通各平台会员，享受额外折扣。</p><h3>总结</h3><p>双十一省钱的秘诀是"提前规划+理性消费"。关注福利导航网，我们会在双11前持续更新最新攻略！</p>',
    category: 'discount',
    author: '省钱达人',
    publishDate: '2026-08-06',
    imageUrl: 'https://readdy.ai/api/search-image?query=Double%20eleven%20shopping%20festival%20illustration%2C%20warm%20festive%20atmosphere%2C%20celebration%20theme%20with%20red%20and%20gold%20accents%2C%20soft%20natural%20lighting%2C%20editorial%20photography%20style%20with%20clean%20composition&width=400&height=300&seq=article-double11-guide-01&orientation=landscape',
    tags: ['双十一', '购物攻略', '省钱技巧', '电商大促'],
  },
  {
    id: 'a6',
    title: '外卖优惠券终极指南：每天省出一杯奶茶钱',
    summary: '美团、饿了么外卖优惠券领取全攻略，包含每日红包、银行立减、会员优惠等，让你每天外卖都能省。',
    contentHtml: '<h3>引言</h3><p>对于每天点外卖的打工人来说，外卖优惠券是刚需。每天省个5-10元，一个月就能省出一顿大餐。本文为你整理最全的外卖优惠券领取渠道。</p><h3>美团外卖优惠券</h3><ul><li><strong>每日签到：</strong>连续签到可领取递增红包。</li><li><strong>会员红包：</strong>开通会员每月6张5元红包。</li><li><strong>银行立减：</strong>使用指定银行卡支付享受随机立减。</li><li><strong>社群红包：</strong>加入美团外卖社群可领取专属红包。</li></ul><h3>饿了么优惠券</h3><ul><li><strong>超级会员：</strong>每月4张5元红包。</li><li><strong>品质联盟券：</strong>部分品质商家可用的大额券。</li><li><strong>支付宝红包：</strong>通过支付宝渠道可领取额外红包。</li></ul><h3>通用技巧</h3><p>1. <strong>错峰点餐：</strong>非高峰时段配送费更低。</p><p>2. <strong>拼单凑满减：</strong>和同事一起拼单，凑满减更划算。</p><p>3. <strong>关注店铺活动：</strong>收藏常点店铺，关注店铺优惠活动。</p><h3>总结</h3><p>外卖省钱并不难，养成领券习惯，每次点餐前花1分钟操作，轻松省下一杯奶茶钱。</p>',
    category: 'coupon',
    author: '福利小助手',
    publishDate: '2026-07-30',
    imageUrl: 'https://readdy.ai/api/search-image?query=Food%20delivery%20coupon%20illustration%2C%20warm%20orange%20and%20beige%20tones%2C%20delicious%20food%20theme%2C%20soft%20natural%20lighting%2C%20editorial%20photography%20style%20with%20clean%20composition&width=400&height=300&seq=article-food-coupon-01&orientation=landscape',
    tags: ['外卖优惠券', '美团', '饿了么', '省钱技巧', '每日红包'],
  },
];

export const testimonials = [
  {
    id: 't1',
    name: '张先生',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20on%20clean%20white%20background%2C%20friendly%20smile%2C%20business%20casual%20style%2C%20warm%20lighting%2C%20simple%20studio%20photography&width=100&height=100&seq=avatar-01&orientation=squarish',
    comment: '福利导航网真是太方便了！以前到处找优惠券浪费时间，现在一个网站全搞定。上个月光用优惠券就省了300多块。',
    rating: 5,
    date: '2026-07-20',
  },
  {
    id: 't2',
    name: '李女士',
    avatar: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20female%20portrait%20on%20clean%20white%20background%2C%20warm%20gentle%20smile%2C%20modern%20professional%20style%2C%20soft%20natural%20lighting%2C%20simple%20studio%20photography&width=100&height=100&seq=avatar-02&orientation=squarish',
    comment: '自从用了福利导航网，我每次购物前都会先来查一查有没有优惠。会员福利板块特别实用，帮我选到了最合适的会员。',
    rating: 5,
    date: '2026-07-25',
  },
  {
    id: 't3',
    name: '王同学',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20student%20portrait%20on%20clean%20white%20background%2C%20bright%20cheerful%20expression%2C%20casual%20style%2C%20warm%20natural%20lighting%2C%20simple%20studio%20photography&width=100&height=100&seq=avatar-03&orientation=squarish',
    comment: '作为一个大学生，省钱就是赚钱。福利导航网的文章质量很高，教了我很多省钱技巧，室友都被我安利了。',
    rating: 5,
    date: '2026-08-01',
  },
  {
    id: 't4',
    name: '赵老板',
    avatar: 'https://readdy.ai/api/search-image?query=Mature%20Chinese%20businessman%20portrait%20on%20clean%20white%20background%2C%20confident%20professional%20look%2C%20formal%20attire%2C%20warm%20studio%20lighting%2C%20simple%20photography&width=100&height=100&seq=avatar-04&orientation=squarish',
    comment: '返利板块非常好用，我公司采购都通过返利链接下单，一个月返了几千块，正规渠道安全可靠。',
    rating: 4,
    date: '2026-07-28',
  },
];

export const faqs = [
  {
    question: '福利导航网是免费的吗？',
    answer: '是的，福利导航网完全免费！我们致力于为用户聚合全网最优质的福利资源，不向用户收取任何费用。您可以直接浏览、领取各类优惠券和福利信息。',
  },
  {
    question: '优惠券领取后如何使用？',
    answer: '在福利导航网找到心仪的优惠券后，点击"立即领取"按钮，系统会自动跳转到对应平台领取页面。领取成功后，优惠券会自动进入您在对应平台的账户中，下单时选择使用即可。',
  },
  {
    question: '返利信息如何操作？',
    answer: '通过福利导航网提供的返利链接进入购物平台下单，确认收货后返利金额会自动计入您的返利账户。不同平台的返利到账时间不同，一般在确认收货后1-7个工作日内到账。',
  },
  {
    question: '福利信息多久更新一次？',
    answer: '我们的团队每天实时监测各大平台的福利信息，确保第一时间更新。限时特惠和秒杀类福利会在活动开始前提前发布，让您有充足时间准备。',
  },
  {
    question: '如何确保福利信息的真实性？',
    answer: '我们所有推荐的福利信息均经过团队人工核实，确保真实有效。所有优惠券、折扣活动均来自官方渠道，返利信息对接正规返利平台。如发现任何问题，欢迎通过联系方式反馈。',
  },
  {
    question: '可以在手机上使用福利导航网吗？',
    answer: '当然可以！福利导航网采用响应式设计，完美适配手机、平板和电脑等多种设备。您在手机上浏览、领取福利的体验同样流畅。',
  },
  {
    question: '如何第一时间获取最新福利？',
    answer: '建议您收藏福利导航网并设为浏览器首页，每天打开即可看到最新福利信息。我们也会在网站首页突出展示当日最热福利，让您不错过任何一个省钱机会。',
  },
];

export const stats = [
  { label: '累计用户', value: '500,000+' },
  { label: '福利资源', value: '10,000+' },
  { label: '合作平台', value: '200+' },
  { label: '累计省钱', value: '5亿元+' },
];